import { render, staticRenderFns } from "./ClientsCourseEdit.vue?vue&type=template&id=1028de18&"
import script from "./ClientsCourseEdit.vue?vue&type=script&lang=js&"
export * from "./ClientsCourseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports